import { TFailureListingOffers, TRequestListingOffers, TSuccessListingOffers } from './loadListingOffers';
import { IPublicWebV1SearchResponse } from '../../repositories/dailyrent/entities/response/PublicWebV1SearchResponse';
import { ITypedReduxAction } from '../../types/redux';

export enum EListingOffersActionType {
  AddOffers = 'listingOffers/addOffers',
  RemoveOffers = 'listingOffers/removeOffers',
  SetPage = 'listingOffers/setPage',
}

export type TAddOffersPayload = Pick<IPublicWebV1SearchResponse, 'offers' | 'offersCount' | 'mlRanking'>;

export type TListingAddOffers = ITypedReduxAction<EListingOffersActionType.AddOffers, TAddOffersPayload>;
export type TListingRemoveOffers = ITypedReduxAction<EListingOffersActionType.RemoveOffers>;
export type TListingSetPage = ITypedReduxAction<EListingOffersActionType.SetPage, number>;

export type TListingOffersActions =
  | TListingAddOffers
  | TListingRemoveOffers
  | TListingSetPage
  | TRequestListingOffers
  | TSuccessListingOffers
  | TFailureListingOffers;
